import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ApiService } from 'src/service/api/api.service';

export const AuthenticationGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree => {
  const authService = inject(ApiService);
  const router = inject(Router);

  const isLoggedIn = authService.isAuthenticated();

  return isLoggedIn ? true : router.parseUrl('/login');
};